import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* ---------- Overlay ---------- */

const useOverlay = makeStyles({
  backdrop: {
    position: "fixed",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    background: "rgba(26,26,26,0.55)",
    padding: 16,
    overflowY: "auto",
    alignItems: ({ align }) => (align === "start" ? "flex-start" : "center"),
    zIndex: ({ z }) => z,
  },
  inner: { width: "100%", display: "flex", justifyContent: "center" },
});

export default function Overlay({ onClose, children, align = "center", z = 1300 }) {
  const c = useOverlay({ align, z });
  return (
    <div onClick={onClose} className={c.backdrop}>
      <div onClick={(e) => e.stopPropagation()} className={c.inner}>
        {children}
      </div>
    </div>
  );
}
